<template>
  <layout>
    <admin-page-header :header="$t('calendars.calendar_header')" />
    <div ref="content" class="content">
      <div class="card">
        <div class="card-header header-elements-inline">
          <h6 class="card-title">{{ $t('calendars.dashboard_title') }}</h6>
          <div class="header-elements"></div>
        </div>

        <div class="card-body" style="">
          <div class="d-md-flex">
            <b-tabs content-class="mt-3" justified>
              <b-tab :title="$t('calendars.dashboard_tab')" active>
                <p>{{ $t('calendars.dashboard_title_api') }}</p>

                <pre
                  id="content"
                  style="white-space: pre-wrap;margin-bottom:15px;min-height: 100px;max-height: 300px;"
                ></pre>
                <!--Add buttons to initiate auth sequence and sign out-->
                <div class="form-group">
                  <button
                    id="get_calendars"
                    class="btn btn-primary"
                    @click="innerGetCalendars"
                  >
                    {{ $t('calendars.get_calendars') }}
                  </button>
                  <button
                    id="delete_calendar"
                    class="btn ml-2 btn-light"
                    @click="innerDeleteCalendar"
                  >
                    {{ $t('calendars.delete_calendar') }}
                  </button>

                  <button
                    id="sync_companies"
                    class="btn ml-2 btn-light"
                    @click="innerSyncCompanies"
                  >
                    {{ $t('calendars.sync_company') }}
                  </button>
                  <button
                    id="sync_booking"
                    class="btn ml-2 btn-light"
                    @click="innerSyncBooking"
                  >
                    {{ $t('calendars.sync_booking') }}
                  </button>
                </div>
              </b-tab>

              <b-tab :title="$t('calendars.calendars')">
                <p v-if="username">
                  {{ $t('calendars.hello') }}, {{ username }}
                </p>
                <div class="form-group">
                  <button
                    v-if="!signed"
                    id="authorize_button"
                    class="btn btn-primary"
                    @click="handleAuthClick"
                  >
                    {{ $t('calendars.authorize') }}
                  </button>
                  <button
                    v-if="signed"
                    id="signout_button"
                    class="btn btn-light"
                    @click="handleSignoutClick"
                  >
                    {{ $t('calendars.logout') }}
                  </button>
                  <button
                    v-if="signed"
                    id="refresh_button"
                    class="btn btn-primary float-right"
                    @click="handleRefreshClick"
                  >
                    {{ $t('calendars.btn_refresh') }}
                  </button>
                </div>
                <b-card no-body>
                  <b-tabs v-if="signed" pills card vertical @changed="onTabChanged">
                    <b-tab
                      v-for="(calendar, index) in calendars"
                      :key="index"
                      :title="calendar.summary"
                      @click="onTabChanged"
                    >
                      <b-card-text>
                        <iframe
                          :data-src="
                            'https://calendar.google.com/calendar/embed?src=' +
                              calendar.id
                          "
                          :src="!index ? 'https://calendar.google.com/calendar/embed?src=' + calendar.id : ''"
                          style="border: 0"
                          width="100%"
                          height="600"
                          frameborder="0"
                          scrolling="no"
                        ></iframe>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
/* globals gapi */
import { AdminPageHeader } from 'stylemix-vue-admin'

export default {
  name: 'Calendar',

  components: {
    AdminPageHeader,
  },
  data() {
    return {
      calendar_id: 'primary',
      calendars: [],
      username: null,
      CLIENT_ID: '',
      GoogleApiLoaded: false,
      auth2: {}, // The Sign-In object.
      googleUser: {}, // The current user.
      updateACL: false,
      gmail: '',
      googleToken: ''
    }
  },
  signed() {
    return !!this.googleToken; // true, если токен есть; false, если токена нет
  },
  mounted() {
    if (!this.GoogleApiLoaded) {
      let promise = this.loadGoogleApi();
      this.$uiBlocker(promise);
      promise.then(() => {
        this.GoogleApiLoaded = true;
        this.$nextTick(this.configureGoogleApi);
      });
    } else {
      this.GoogleApiLoaded = true;
      this.$nextTick(this.configureGoogleApi);
    }
    const savedToken = localStorage.getItem('googleToken');
    if (savedToken) {
      this.googleToken = savedToken;
      const decodedToken = JSON.parse(atob(savedToken.split('.')[1]));
      this.username = decodedToken.name;
      this.setGmail(decodedToken.email);
      this.signed = true;
    }
    this.innerGetCalendars();
  },
  methods: {
    handleCredentialResponse(response) {
      if (response.credential) {
        const decodedToken = JSON.parse(atob(response.credential.split('.')[1]));
        this.username = decodedToken.name;
        this.setGmail(decodedToken.email);
        this.signed = true;
        this.googleToken = response.credential;
        localStorage.setItem('googleToken', response.credential);
      } else {
        /* eslint-disable-next-line no-console */
        console.error('Error authorization:', response);
      }
    },
    handleAuthClick() {
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          /* eslint-disable-next-line no-console */
          console.error('Error: popup not visible.');
        }
      });
    },
    handleSignoutClick() {
      this.signed = false;
      this.username = null;
      this.googleToken = null;
      localStorage.removeItem('googleToken');
      /* eslint-disable-next-line no-console */
      console.log('You logout.');
    },
    clearPre() {
      var pre = document.getElementById('content')
      pre.innerHTML = ''
    },
    onTabChanged(event) {
      let attr = event.target.getAttribute('id');
      let iframe = document.querySelector('[aria-labelledby="'+attr+'"]').querySelector('iframe');
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
    },
    appendPre(message) {
      var pre = document.getElementById('content')
      var textContent = document.createTextNode(message + '\n')
      pre.appendChild(textContent)
    },
    loadGoogleApi() {
      return new Promise(resolve => {
        let api = document.createElement('script')
        api.onload = resolve
        api.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(api)
      })
    },
    configureGoogleApi() {
      this.handleClientLoad()
    },
    async handleClientLoad() {
      window.google.accounts.id.initialize({
        client_id: this.$settings.google_api_calendar_id,
        callback: this.handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
      });
    },
    setGmail(gmail) {
      if (!gmail) return
      let calendars = this.calendars
      document.getElementsByClassName('calendar_frame')
      if (calendars && calendars.length) {
        let temp = []
        for (var i in calendars) temp.push(calendars[i].id)
        this.$http.put('google/setgmail', {
          cid: temp,
          gmail: gmail,
        })
      }
    },
    changeCalendar(event) {
      this.calendar_id = event.target.value
    },
    serializeFormObject(form) {
      let elements = form.querySelectorAll('input, select, textarea')
      let obj = {}
      for (let i = 0; i < elements.length; ++i) {
        let element = elements[i]
        let name = element.name
        let value = element.value

        if (name) obj[name] = value
      }
      return obj
    },
    innerfillCalendarsList() {
      let self = this
      let promise = this.$http.get('google/c-list')
      this.$uiBlocker(promise, document.getElementById('content'))
      promise.then(result => {
        let temp = []
        self.updateACL = false
        let calendars = result.data.calendars
        for (let i in calendars) temp.push(calendars[i])
        self.calendars = temp
      })
    },
    innerGetCalendars() {
      let self = this
      let promise = this.$http.get('google/c-list')
      this.$uiBlocker(promise, document.getElementById('content'))
      promise.then(result => {
        let temp = []
        let calendars = result.data.calendars
        this.clearPre()
        for (let i in calendars) {
          temp.push(calendars[i])
          this.appendPre('Event: ' + calendars[i].summary)
          this.appendPre('   id: ' + calendars[i].id)
        }
        self.calendars = temp
      })
    },
    innerDeleteCalendar() {
      let cid = prompt(this.$t('calendars.input_cal_id'))
      let self = this
      if (!cid) return
      let promise = this.$http.post('google/c-delete', { cid: cid })
      this.$uiBlocker(promise, document.getElementById('content'))
      promise.then(result => {
        self.appendPre('Calendar: ' + result.data.message)
      })
    },
    innerSyncCompanies() {
      let self = this
      let promise = this.$http.get('google/sync-comp')
      this.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        this.clearPre()
        for (var i in result.data.companies) {
          let company = result.data.companies[i]
          self.appendPre('Company: ' + company.name)
          self.appendPre('     ID: ' + company.id)
          self.appendPre('    RID: ' + company.rid)
          self.appendPre(' Status: ' + company.status)
          self.appendPre('')
        }
      })
    },
    innerSyncBooking() {
      let self = this
      let promise = this.$http.get('google/sync-book')
      this.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        this.clearPre()
        self.appendPre('Mess: ' + result.data.message)
      })
    },
    handleRefreshClick() {
      window.location.reload(false)
    },
  },
}
</script>

<style type="text/css">
div.tabs {
  width: 100%;
}
</style>
